import { render } from "./App.vue?vue&type=template&id=e5db058a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e5db058a&lang=css"

import exportComponent from "/Users/matthewnorth/Documents/Projects/ip-address-tracker-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__